import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Head from 'components/Head';

const ErrorPage = ({ errorCode }) => (
  <>
    <Head title={`Error ${errorCode}`} />
    <div className="center" style={{ padding: 50 }}>
      <img src="/assets/img/error.png" alt="error-404" />
      <h1>Error {errorCode}</h1>
      <Button type="a" to="/projects">
        Take me home
      </Button>
    </div>
  </>
);

ErrorPage.propTypes = {
  errorCode: PropTypes.number,
};

ErrorPage.defaultProps = {
  errorCode: 404,
};

export default ErrorPage;
